/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Manual_NoteInputs */

const en_mk_build_manual_note = /** @type {(inputs: Mk_Build_Manual_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the official agent login or your own API key. CLI and MCP integrations remain available for your development tools.`)
};

const id_mk_build_manual_note = /** @type {(inputs: Mk_Build_Manual_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan login resmi agent atau API key sendiri. Integrasi CLI dan MCP tetap tersedia untuk alat pengembanganmu.`)
};

/**
* | output |
* | --- |
* | "Use the official agent login or your own API key. CLI and MCP integrations remain available for your development tools." |
*
* @param {Mk_Build_Manual_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_manual_note = /** @type {((inputs?: Mk_Build_Manual_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Manual_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_manual_note(inputs)
	return en_mk_build_manual_note(inputs)
});